// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-customer #email{direction:ltr;text-align:right}", "",{"version":3,"sources":["webpack://./client/app/components/order/order-customer/order-customer.scss"],"names":[],"mappings":"AACE,uBACE,aAAA,CACA,gBAAA","sourcesContent":[".order-customer {\r\n  #email {\r\n    direction: ltr;\r\n    text-align: right;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
